export default __webpack_public_path__ + "static/media/ic-arrow-head-down.1f46f46d.svg";